import script from "./VideoCardTile.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoCardTile.vue?vue&type=script&setup=true&lang=js"

import "./VideoCardTile.vue?vue&type=style&index=0&id=1e5016c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e5016c5"]])

export default __exports__